(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wh-commerce"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('wh-commerce'))customElements.define('wh-commerce',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;this.abort=new AbortController();this.text=JSON.parse(this.querySelector('[data-wh-texts]').textContent);this.quick=this.querySelector('#wh-quick-dialog');this.cache=new Map();this.busy=false;this.quickRevision=0;this.refreshRevision=0;const opts={signal:this.abort.signal};
      document.documentElement.classList.add('wh-commerce-ready');
      document.addEventListener('click',event=>this.click(event),opts);
      document.addEventListener('change',event=>{const input=event.target.closest('[data-cart-quantity]');if(input)this.change(input.dataset.key,Number(input.value),input);},opts);
      document.addEventListener('shopify:cart:lines-update',event=>{event.promise?.then(result=>{if(result.detail?.didError)return;if(event.action==='add'){this.openBag(this.text.done);this.refresh();}else this.refresh();}).catch(()=>{});},opts);
      document.addEventListener('shopify:cart:discount-update',event=>event.promise?.then(()=>this.refresh()).catch(()=>{}),opts);
      this.quick.addEventListener('close',()=>{this.quickRevision++;document.documentElement.classList.remove('wh-quick-open');this.append(this.quick);if(this.quickReturn?.isConnected)this.quickReturn.focus({preventScroll:true});},opts);
      this.quick.addEventListener('keydown',event=>{if(event.key==='Escape')event.stopPropagation();},opts);
      this.quick.addEventListener('click',event=>{if(event.target===this.quick){const r=this.quick.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.quick.close();}},opts);
      window.addEventListener('pageshow',event=>{if(event.persisted)this.refresh();},opts);
    }
    disconnectedCallback(){this.abort?.abort();this.ready=false;}
    async click(event){
      const opener=event.target.closest('[data-wh-quick]');if(opener){event.preventDefault();this.openQuick(opener);return;}
      const bag=event.target.closest('[data-wh-bag-open]');if(bag){const drawer=document.querySelector('theme-drawer#cart-drawer');if(drawer?.open){event.preventDefault();this.openBag('');this.refresh();}return;}
      if(event.target.closest('[data-quick-close]')){this.quick.close();return;}
      const option=event.target.closest('[data-quick-option]');if(option){this.chosen[Number(option.dataset.optionIndex)]=option.dataset.quickOption;this.renderOptions();return;}
      if(event.target.closest('[data-quick-submit]')){await this.add();return;}
      const step=event.target.closest('[data-cart-step]');if(step){const line=step.closest('[data-cart-line]');const quantity=Number(line.querySelector('[data-cart-quantity]').value);await this.change(step.dataset.key,quantity+Number(step.dataset.cartStep),step);return;}
      const remove=event.target.closest('[data-cart-remove]');if(remove){event.preventDefault();await this.change(remove.dataset.key,0,remove);return;}
      const back=event.target.closest('[data-cart-continue]');if(back&&back.closest('#cart-drawer')){event.preventDefault();document.querySelector('theme-drawer#cart-drawer')?.close();}
    }
    money(value){try{return new Intl.NumberFormat(this.dataset.locale||'en',{style:'currency',currency:this.dataset.currency||'USD',maximumFractionDigits:2}).format(value/100);}catch{return String(value/100);}}
    async openQuick(opener){
      const revision=++this.quickRevision;this.quickReturn=opener;this.product=null;this.variant=null;this.lastUrl=opener.dataset.whQuick;
      this.quick.querySelector('#wh-quick-title').textContent=this.text.loading;this.quick.querySelector('[data-quick-options]').replaceChildren();this.quick.querySelector('[data-quick-price]').textContent='';this.quick.querySelector('[data-quick-photo]').hidden=true;this.quick.querySelector('[data-quick-message]').textContent='';this.quick.querySelector('[data-quick-details]').href=this.lastUrl;this.quick.querySelector('[data-quick-submit]').disabled=true;this.quick.querySelector('[data-quick-submit]').textContent=this.text.select;
      const host=document.querySelector('#cart-drawer[open] > dialog')||this;if(this.quick.parentElement!==host)host.append(this.quick);document.documentElement.classList.add('wh-quick-open');if(!this.quick.open)this.quick.showModal();
      try{
        const url=new URL(this.lastUrl,location.origin);url.search='';url.hash='';url.pathname=url.pathname.replace(/\/$/,'')+'.js';
        let product=this.cache.get(url.href);if(!product){const response=await fetch(url,{headers:{Accept:'application/json'}});if(!response.ok)throw Error(this.text.error);product=await response.json();this.cache.set(url.href,product);}
        if(revision!==this.quickRevision)return;this.product=product;
        const colour=opener.closest('wh-shop-card')?.querySelector('[data-card-colour][aria-pressed="true"]')?.title;
        this.chosen=product.options.map(option=>option.values.length===1?option.values[0]:null);
        const colourIndex=product.options.findIndex(option=>/^(color|colour|farbe)$/i.test(option.name)&&option.values.length>1);
        if(colourIndex>=0){const values=product.options[colourIndex].values;this.chosen[colourIndex]=values.includes(colour)?colour:values.includes('White')?'White':values[0];}
        this.quick.querySelector('#wh-quick-title').textContent=product.title.replace(/^Weekend Heir /i,'');this.renderOptions();
      }catch(error){if(revision!==this.quickRevision)return;this.quick.querySelector('#wh-quick-title').textContent=this.text.choose;this.quick.querySelector('[data-quick-message]').textContent=this.text.error;}
    }
    renderOptions(){
      const p=this.product;if(!p)return;const container=this.quick.querySelector('[data-quick-options]');container.replaceChildren();
      p.options.forEach((option,index)=>{
        const field=document.createElement('fieldset'),legend=document.createElement('legend');legend.textContent=option.name+(this.chosen[index]?' — '+this.chosen[index]:'');field.append(legend);
        option.values.forEach(value=>{
          const button=document.createElement('button');button.type='button';button.dataset.quickOption=value;button.dataset.optionIndex=index;button.textContent=value;button.setAttribute('aria-pressed',String(this.chosen[index]===value));
          const possible=p.variants.some(v=>v.available&&v.options[index]===value&&v.options.every((current,i)=>i===index||!this.chosen[i]||/^(color|colour|farbe)$/i.test(option.name)||current===this.chosen[i]));
          button.disabled=!possible||this.busy;field.append(button);
        });container.append(field);
      });
      this.variant=p.variants.find(v=>v.options.every((value,index)=>value===this.chosen[index]));
      const colourIndex=p.options.findIndex(option=>/^(color|colour|farbe)$/i.test(option.name)&&option.values.length>1);const colour=colourIndex>=0?this.chosen[colourIndex]?.toLowerCase():null;
      const media=p.media?.find(m=>m.media_type==='image'&&(!colour||m.alt?.split('|')[0].trim().toLowerCase()===colour));
      const photo=this.quick.querySelector('[data-quick-photo]');const src=media?.preview_image?.src||(!colour?p.featured_image:null);photo.hidden=!src;if(src){photo.src=src+(src.includes('?')?'&':'?')+'width=640';photo.alt=media?.alt||p.title;}
      const fallback=p.variants.find(v=>v.available&&(!colour||v.options[colourIndex]?.toLowerCase()===colour));this.quick.querySelector('[data-quick-price]').textContent=this.money(this.variant?.price??fallback?.price??p.price);
      const button=this.quick.querySelector('[data-quick-submit]');const missing=p.options.find((option,index)=>!this.chosen[index]);button.textContent=missing?(/^size|größe|groesse$/i.test(missing.name)?this.text.select_size:this.text.select):this.variant?.available?this.text.add:this.text.sold;button.disabled=!!missing||!this.variant?.available||this.busy;
      this.quick.querySelector('[data-quick-details]').href=this.lastUrl.split('?')[0]+(this.variant?'?variant='+this.variant.id:'');this.quick.querySelector('[data-quick-message]').textContent='';
    }
    setBusy(value){this.busy=value;document.querySelectorAll('[data-wh-cart-view]').forEach(view=>{view.setAttribute('aria-busy',String(value));view.querySelectorAll('button,input').forEach(element=>element.disabled=value);});if(this.product)this.renderOptions();}
    async add(){
      if(this.busy||!this.variant?.available)return;const id=this.variant.id;this.setBusy(true);const button=this.quick.querySelector('[data-quick-submit]');button.textContent=this.text.adding;
      let added=false;let failure='';
      try{
        const response=await fetch(this.dataset.addUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id,quantity:1}],sections:['wh-cart-panel','wh-cart-page'],sections_url:this.dataset.cartUrl})});
        const result=await response.json();if(!response.ok||result.status)throw Error(result.description||this.text.error);added=true;this.quick.close();this.openBag(this.text.done);
        if(!this.applySections(result.sections))await this.refresh();document.querySelector('#cart-drawer .theme-drawer__close-button')?.focus({preventScroll:true});
      }catch(error){if(added)this.message(this.text.refresh_error,true);else failure=error.message||this.text.error;}
      finally{this.setBusy(false);if(!added)this.quick.querySelector('[data-quick-message]').textContent=failure||this.text.error;}
    }
    async change(key,quantity,trigger){
      if(this.busy||!Number.isInteger(quantity)||quantity<0)return;
      const step=trigger.dataset.cartStep;const view=trigger.closest('[data-wh-cart-view]');this.setBusy(true);
      try{
        const response=await fetch(this.dataset.changeUrl+'.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity,sections:['wh-cart-panel','wh-cart-page'],sections_url:this.dataset.cartUrl})});
        const result=await response.json();if(!response.ok||result.status)throw Error(result.description||this.text.error);
        if(!this.applySections(result.sections))await this.refresh();this.message(this.text.updated);
        const candidates=[...(view||document).querySelectorAll('[data-key]')];const target=candidates.find(el=>el.dataset.key===key&&(step?el.dataset.cartStep===step:el.hasAttribute('data-cart-quantity')));(target||view?.querySelector('.wh-cart-product,.wh-primary'))?.focus({preventScroll:true});
      }catch(error){this.message(error.message||this.text.error,true);await this.refresh();}
      finally{this.setBusy(false);}
    }
    openBag(message){
      const drawer=document.querySelector('theme-drawer#cart-drawer');if(drawer?.open){if(!drawer.isOpen)drawer.open();this.message(message);}else{this.toast(message||this.text.updated);}
    }
    applySections(sections){
      if(!sections?.['wh-cart-panel']||!sections?.['wh-cart-page'])return false;
      const parser=new DOMParser();let count=null;
      for(const mode of ['drawer','page']){
        const doc=parser.parseFromString(sections[mode==='drawer'?'wh-cart-panel':'wh-cart-page'],'text/html');const content=doc.querySelector('[data-wh-cart-content="'+mode+'"]');if(!content)return false;
        count=content.dataset.count;document.querySelectorAll('[data-wh-cart-view="'+mode+'"]').forEach(view=>view.replaceChildren(content.cloneNode(true)));
      }
      document.querySelectorAll('[data-wh-bag-count]').forEach(node=>node.textContent='('+count+')');return true;
    }
    async refresh(){
      const revision=++this.refreshRevision;
      try{const url=new URL(this.dataset.cartUrl,location.origin);url.searchParams.set('sections','wh-cart-panel,wh-cart-page');const response=await fetch(url,{headers:{Accept:'application/json'},cache:'no-store'});if(!response.ok)throw Error();const data=await response.json();if(revision!==this.refreshRevision)return;if(!this.applySections(data))throw Error();}
      catch{this.message(this.text.refresh_error,true);}
    }
    message(text,error=false){document.querySelectorAll('[data-cart-message]').forEach(node=>{node.textContent=text;node.classList.toggle('is-error',error);node.hidden=!text;});}
    toast(text){const node=this.querySelector('[data-commerce-toast]');node.textContent=text;node.hidden=false;clearTimeout(this.toastTimer);this.toastTimer=setTimeout(()=>node.hidden=true,5000);}
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wh-pdp-behavior"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wh-product-page')) {
    customElements.define('wh-product-page', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        const config = this.querySelector('[data-whp-config]');
        if (!config) {
          this.delayedInit = () => this.connectedCallback();
          document.addEventListener('DOMContentLoaded', this.delayedInit, { once: true });
          return;
        }
        this.config = JSON.parse(config.textContent);
        this.ready = true;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.strings = this.config.strings;
        this.variants = this.config.variants;
        this.current = this.variants.find(v => v.id === this.config.selected) || this.variants[0];
        if (!this.current) return;
        this.selected = this.current.options.map((value, index) => this.config.explicitSelection || index === this.config.colorIndex ? value : null);
        if (this.current.options.length === 1 && this.config.sizeIndex < 0 && this.config.colorIndex < 0 && this.current.options[0] === 'Default Title') this.selected = [...this.current.options];
        this.form = this.querySelector('.whp-form');
        this.native = this.querySelector('[data-native-variant]');
        this.slides = [...this.querySelectorAll('[data-image-id]')];
        this.thumbs = [...this.querySelectorAll('[data-thumb-id]')];
        this.activeImage = this.slides.find(s => !s.hidden)?.dataset.imageId;
        this.zoomDialog = this.querySelector('.whp-zoom');
        this.addButton = this.querySelector('[data-add]');
        this.sticky = this.querySelector('[data-sticky]');
        this.querySelectorAll('[data-enhanced-only]').forEach(element => { element.hidden = false; });
        this.querySelector('.whp-native').hidden = true;
        this.addEventListener('change', event => this.onChange(event), options);
        this.addEventListener('click', event => this.onClick(event), options);
        this.form.addEventListener('submit', event => this.addToBag(event), options);
        this.querySelectorAll('dialog').forEach(dialog => {
          dialog.addEventListener('close', () => { dialog.opener?.focus({ preventScroll: true }); this.refreshSticky(); }, options);
          dialog.addEventListener('click', event => {
            if (event.target !== dialog) return;
            const rect = dialog.getBoundingClientRect();
            if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
          }, options);
        });
        this.addEventListener('keydown', event => {
          if (!this.zoomDialog.open) return;
          if (event.key === 'ArrowRight') { event.preventDefault(); this.moveGallery(1); }
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.moveGallery(-1); }
        }, options);
        const stage = this.querySelector('[data-gallery-stage]');
        stage?.addEventListener('touchstart', event => { const touch = event.touches[0]; this.touchStart = { x: touch.clientX, y: touch.clientY }; }, { ...options, passive: true });
        stage?.addEventListener('touchend', event => {
          if (!this.touchStart) return;
          const touch = event.changedTouches[0];
          const dx = touch.clientX - this.touchStart.x;
          const dy = touch.clientY - this.touchStart.y;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) { this.moveGallery(dx < 0 ? 1 : -1); this.swipedAt = Date.now(); }
          this.touchStart = null;
        }, { ...options, passive: true });
        this.update(false, true);
        this.observer = new IntersectionObserver(entries => {
          for (const entry of entries) if (entry.target === this.addButton) this.mainButtonVisible = entry.isIntersecting;
          this.refreshSticky();
        }, { threshold: 0.1 });
        this.observer.observe(this.addButton);
        this.scrollHandler = () => this.refreshSticky();
        window.addEventListener('scroll', this.scrollHandler, { ...options, passive: true });
        window.addEventListener('popstate', () => this.restoreUrl(), options);
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        if (this.delayedInit) document.removeEventListener('DOMContentLoaded', this.delayedInit);
        this.ready = false;
      }
      onChange(event) {
        const input = event.target.closest('[data-option-input]');
        if (!input) return;
        const index = Number(input.closest('[data-option-index]').dataset.optionIndex);
        this.selected[index] = input.value;
        this.querySelector('[data-selection-note]').textContent = '';
        if (index === this.config.colorIndex) {
          this.selected.forEach((value, otherIndex) => {
            if (otherIndex === index || value == null) return;
            const allowed = this.variants.some(v => v.available && v.options[index] === input.value && v.options[otherIndex] === value);
            if (!allowed) { this.selected[otherIndex] = null; this.querySelector('[data-selection-note]').textContent = this.strings.sizeReset; }
          });
        }
        this.querySelector('[data-added]').hidden = true;
        this.querySelector('[data-form-error]').hidden = true;
        this.update(true, index === this.config.colorIndex);
      }
      update(writeUrl = true, resetGallery = false) {
        this.current = this.variants.find(v => v.options.every((value, index) => value === this.selected[index]));
        const colorIndex = this.config.colorIndex;
        this.querySelectorAll('[data-option-index]').forEach(fieldset => {
          const index = Number(fieldset.dataset.optionIndex);
          fieldset.querySelectorAll('[data-option-input]').forEach(input => {
            input.checked = input.value === this.selected[index];
            const allowed = this.variants.some(v => v.available && v.options[index] === input.value && (index === colorIndex || this.selected.every((selected, other) => other === index || selected == null || v.options[other] === selected)));
            input.disabled = !allowed;
          });
        });
        const colorField = this.querySelector(`[data-option-index="${colorIndex}"]`);
        this.colorKey = colorField?.querySelector('input:checked')?.dataset.key || '';
        const colorLabel = this.querySelector('[data-color-label]');
        if (colorLabel) colorLabel.textContent = this.selected[colorIndex] || '';
        const match = this.current || this.variants.find(v => v.available && this.selected.every((selected, index) => selected == null || v.options[index] === selected)) || this.variants.find(v => v.options[colorIndex] === this.selected[colorIndex]) || this.variants[0];
        if (match) {
          this.querySelector('[data-price]').textContent = match.price;
          this.querySelector('[data-sticky-price]').textContent = match.price;
          const compare = this.querySelector('[data-compare]');
          compare.hidden = !match.compare;
          compare.textContent = match.compare || '';
        }
        this.native.disabled = !this.current?.available;
        if (this.current) this.native.value = String(this.current.id);
        const incomplete = this.selected.some(value => value == null);
        let label = this.strings.add;
        if (incomplete) label = this.config.sizeIndex >= 0 && this.selected[this.config.sizeIndex] == null ? this.strings.chooseSize : this.strings.chooseOptions;
        else if (!this.current) label = this.strings.unavailable;
        else if (!this.current.available) label = this.strings.soldOut;
        this.addButton.disabled = this.busy || (!incomplete && !this.current?.available);
        this.querySelector('[data-add-label]').textContent = this.busy ? this.strings.adding : label;
        this.querySelector('[data-sticky-label]').textContent = this.busy ? this.strings.adding : label;
        this.querySelector('[data-sticky-add]').disabled = this.addButton.disabled;
        this.querySelector('[data-sticky-summary]').textContent = this.selected.filter(Boolean).join(' / ');
        this.visibleSlides = this.slides.filter(slide => colorIndex < 0 || slide.dataset.color === this.colorKey);
        this.thumbs.forEach(thumb => { thumb.hidden = !this.visibleSlides.some(slide => slide.dataset.imageId === thumb.dataset.thumbId); });
        if (resetGallery || !this.visibleSlides.some(slide => slide.dataset.imageId === this.activeImage)) this.activeImage = (this.visibleSlides.find(slide => slide.dataset.view === 'back') || this.visibleSlides[0])?.dataset.imageId;
        this.showImage(this.activeImage);
        this.querySelectorAll('[data-size-row]').forEach(row => row.classList.toggle('is-selected', row.dataset.sizeRow === this.selected[this.config.sizeIndex]));
        if (writeUrl) {
          const url = new URL(window.location.href);
          if (this.current) url.searchParams.set('variant', String(this.current.id));
          else url.searchParams.delete('variant');
          window.history.replaceState({}, '', url);
        }
      }
      showImage(id) {
        this.activeImage = id;
        this.slides.forEach(slide => { slide.hidden = slide.dataset.imageId !== id || !this.visibleSlides.includes(slide); });
        this.thumbs.forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb.dataset.thumbId === id)));
        const index = this.visibleSlides.findIndex(slide => slide.dataset.imageId === id);
        const slide = this.visibleSlides[index];
        const counter = this.querySelector('[data-gallery-counter]');
        counter.textContent = index < 0 ? '0 / 0' : `${String(index + 1).padStart(2, '0')} / ${String(this.visibleSlides.length).padStart(2, '0')}`;
        const view = this.strings[slide?.dataset.view] || this.strings.detail;
        this.querySelector('[data-gallery-caption]').textContent = view;
        this.querySelectorAll('[data-gallery-prev],[data-gallery-next]').forEach(button => { button.disabled = this.visibleSlides.length < 2; });
        this.querySelectorAll('[data-zoom]').forEach(button => { button.disabled = !slide; });
        if (this.zoomDialog.open) this.updateZoom();
      }
      moveGallery(delta) {
        if (this.visibleSlides.length < 2) return;
        const index = this.visibleSlides.findIndex(slide => slide.dataset.imageId === this.activeImage);
        this.showImage(this.visibleSlides[(index + delta + this.visibleSlides.length) % this.visibleSlides.length].dataset.imageId);
      }
      openDialog(dialog, opener) {
        if (!dialog || dialog.open) return;
        dialog.opener = opener;
        dialog.showModal();
        this.refreshSticky();
      }
      updateZoom() {
        const source = this.visibleSlides.find(slide => slide.dataset.imageId === this.activeImage)?.querySelector('img');
        if (!source) return;
        const image = this.querySelector('[data-zoom-image]');
        const url = new URL(source.getAttribute('src'), window.location.href);
        url.searchParams.set('width', '1800');
        image.src = url.href;
        image.alt = source.alt;
        this.querySelector('[data-zoom-caption]').textContent = `${this.selected[this.config.colorIndex] || ''} · ${this.querySelector('[data-gallery-caption]').textContent}`;
      }
      onClick(event) {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-thumb-id')) this.showImage(button.dataset.thumbId);
        if (button.hasAttribute('data-gallery-prev')) this.moveGallery(-1);
        if (button.hasAttribute('data-gallery-next')) this.moveGallery(1);
        if (button.hasAttribute('data-zoom')) {
          if (Date.now() - (this.swipedAt || 0) < 350) return;
          this.updateZoom(); this.openDialog(this.zoomDialog, button);
        }
        if (button.hasAttribute('data-close-dialog')) button.closest('dialog').close();
        if (button.hasAttribute('data-size-guide')) this.openDialog(this.querySelector('.whp-size-dialog'), button);
        if (button.hasAttribute('data-sticky-add')) this.current?.available ? this.form.requestSubmit(this.addButton) : this.focusSelection();
        if (button.hasAttribute('data-unit')) {
          const cm = button.dataset.unit === 'cm';
          this.querySelectorAll('[data-unit]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          this.querySelectorAll('[data-measure-unit]').forEach(item => { item.textContent = button.dataset.unit; });
          this.querySelectorAll('[data-inches]').forEach(cell => { cell.textContent = cm ? (Number(cell.dataset.inches) * 2.54).toFixed(1) : cell.dataset.inches; });
        }
      }
      focusSelection() {
        let index = this.selected.findIndex(value => value == null);
        if (index < 0) index = this.config.sizeIndex;
        const field = this.querySelector(`[data-option-index="${index}"]`);
        field?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
        field?.querySelector('input:not(:disabled)')?.focus({ preventScroll: true });
        this.querySelector('[data-selection-note]').textContent = index === this.config.sizeIndex ? this.strings.chooseSize : this.strings.chooseOptions;
      }
      async addToBag(event) {
        event.preventDefault();
        if (this.busy) return;
        if (!this.current?.available) { this.focusSelection(); return; }
        const selectedVariant = this.current;
        this.busy = true;
        this.addButton.setAttribute('aria-busy', 'true');
        this.querySelector('[data-form-error]').hidden = true;
        this.querySelector('[data-added]').hidden = true;
        this.querySelectorAll('[data-option-index]').forEach(fieldset => { fieldset.disabled = true; });
        this.update(false);
        try {
          const response = await fetch(this.config.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: selectedVariant.id, quantity: 1 }] }) });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || this.strings.error);
          this.querySelector('[data-added]').hidden = false;
          this.dispatchEvent(new CustomEvent('wh:cart-added', { bubbles: true, detail: { items: data.items || [data] } }));
          window.location.assign(this.config.cartUrl);
        } catch (error) {
          const target = this.querySelector('[data-form-error]');
          target.textContent = error.message === 'Failed to fetch' ? this.strings.error : error.message;
          target.hidden = false;
        } finally {
          this.busy = false;
          this.addButton.removeAttribute('aria-busy');
          this.querySelectorAll('[data-option-index]').forEach(fieldset => { fieldset.disabled = false; });
          this.update(false);
        }
      }
      refreshSticky() {
        if (!this.sticky || !this.addButton) return;
        const rect = this.addButton.getBoundingClientRect();
        const passed = rect.bottom < 0;
        this.sticky.hidden = !passed || !!this.querySelector('dialog[open]');
      }
      restoreUrl() {
        const id = new URL(window.location.href).searchParams.get('variant');
        const variant = this.variants.find(item => String(item.id) === id);
        if (!variant) return;
        this.selected = [...variant.options];
        this.update(false, true);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wh-shop-card"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('wh-shop-card'))customElements.define('wh-shop-card',class extends HTMLElement{
    connectedCallback(){if(this.ready)return;this.ready=true;this.addEventListener('click',event=>{const button=event.target.closest('[data-card-colour]');if(button&&!button.disabled)this.selectColour(button.dataset.cardColour);});}
    selectColour(colour){const button=[...this.querySelectorAll('[data-card-colour]')].find(b=>b.dataset.cardColour===colour&&!b.disabled);if(!button)return;this.querySelectorAll('[data-card-colour]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));this.querySelectorAll('[data-card-link]').forEach(a=>a.href=button.dataset.url);this.querySelector('[data-card-price]').textContent=button.dataset.price;this.querySelector('[data-card-colour-name]').textContent=button.title;for(const [selector,key]of[['.wh-shop-card-main','main'],['.wh-shop-card-alt','alt']]){const image=this.querySelector(selector);if(!image)continue;const src=button.dataset[key];image.hidden=!src;if(src){image.removeAttribute('srcset');image.src=src;image.alt=button.dataset[key+'Label']||button.title;}}}
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wh-styles"] && !Shopify.designMode) return;
  try {
    if(!window.whInteractionsReady){
    window.whInteractionsReady=true;
    document.addEventListener('click',(event)=>{
      const opener=event.target.closest('[data-wh-open]');
      if(opener){const dialog=document.getElementById(opener.dataset.whOpen);if(dialog){dialog.whOpener=opener;dialog.showModal();}}
      const close=event.target.closest('[data-wh-close]');
      if(close){const dialog=close.closest('dialog');dialog?.close();dialog?.whOpener?.focus();}
      if(event.target.matches('dialog.wh-dialog')){const r=event.target.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)event.target.close();}
      const color=event.target.closest('[data-wh-color]');
      if(color){const scope=color.closest('[data-wh-scope]');scope?.querySelectorAll('.wh-garment').forEach(g=>g.classList.toggle('is-black',color.dataset.whColor==='black'));color.parentElement.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',b===color));}
      const view=event.target.closest('[data-wh-view]');
      if(view){const scope=view.closest('[data-wh-scope]');scope?.querySelectorAll('.wh-garment').forEach(g=>g.classList.toggle('is-front',view.dataset.whView==='front'));view.parentElement.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',b===view));}
      const anchor=event.target.closest('a[href*="#membership"]');
      if(anchor){anchor.closest('dialog')?.close();}
    });
  }
  } catch(e) { console.error(e); }
})();

})();
